export const INIT_OIL_BY_COMPANY_REQUEST = 'INIT_OIL_BY_COMPANY_REQUEST';
export const SET_OIL_BY_COMPANY = 'SET_OIL_BY_COMPANY';
export const ERROR_OIL_BY_COMPANY = 'ERROR_OIL_BY_COMPANY';

export function initOilByCompanyRequest() {
    return { type: INIT_OIL_BY_COMPANY_REQUEST };
  }
  
  export function setOilByCompany(data) {
    return { type: SET_OIL_BY_COMPANY, payload: data };
  }
  
  export function errorOilByCompany(error) {
    return { type: ERROR_OIL_BY_COMPANY, payload: error };
  }
  